import { render, staticRenderFns } from "./GridSituacaoAcademica.vue?vue&type=template&id=583a9d46&scoped=true&"
import script from "./GridSituacaoAcademica.vue?vue&type=script&lang=js&"
export * from "./GridSituacaoAcademica.vue?vue&type=script&lang=js&"
import style0 from "./GridSituacaoAcademica.vue?vue&type=style&index=0&id=583a9d46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583a9d46",
  null
  
)

export default component.exports